import { SelfSchedulePatient } from "./self-schedule";

export enum PatientClaimAuthMode {
  PHONE = "phone",
  PORTAL = "portal",
  NONE = "none",
}

export interface PhoneCandidatesResponse {
  authMode: PatientClaimAuthMode.PHONE;
  candidates: SelfSchedulePatient[];
  claimedPatientId: string | null;
}

export interface PortalCandidatesResponse {
  authMode: PatientClaimAuthMode.PORTAL;
  patient: SelfSchedulePatient;
}

export interface NoLinkedPatientResponse {
  authMode: PatientClaimAuthMode.NONE;
}

export type CandidatesResponse =
  | PhoneCandidatesResponse
  | PortalCandidatesResponse
  | NoLinkedPatientResponse;
